import { boolean, object, string } from "yup";
import { applyPasswordRules } from "~/utils/PasswordValidationUtil";

// TODO 必須項目が埋まったら型定義を変える
export type VendorCompany = {
	address: string | null;
	allowPartiallyFinished: boolean;
	ceoFirstName: string | null;
	ceoLastName: string | null;
	email: string;
	estimationNoteTemplate: string | null;
	fax: string | null;
	id: number;
	loginEmail: string;
	name: string;
	postalCode: string | null;
	staffName: string;
	teamName: string;
	tel: string | null;
	useLineNotification?: boolean;
	/** vendor_partnersを持っているか */
	usePartner: boolean;
};

export type VendorCompanyLoginParams = {
	email: string;
	password: string;
};

export type VendorToCompanySetting = {
	dealVendorNoteTemplate: string | null;
	defaultCautionaryNoteToCompany: string | null;
};

export type VendorCompanyPasswordResetParams = {
	confirmPassword: string;
	newPassword: string;
};

type OptionalProp =
	| "id"
	| "ceoLastName"
	| "ceoFirstName"
	| "email"
	| "postalCode"
	| "address"
	| "allowPartiallyFinished"
	| "usePartner";

export type VendorCompanyUpdateSelfParams = Omit<
	VendorCompany,
	OptionalProp
> & {
	address: string;
	ceoFirstName: string;
	ceoLastName: string;
	dealVendorNoteTemplate: string;
	defaultCautionaryNoteToCompany: string;
	estimationNoteTemplate: string;
	postalCode: string;
};

export type VendorCompanyCreateParams = Omit<
	VendorCompanyUpdateSelfParams,
	| "tel"
	| "fax"
	| "teamName"
	| "staffName"
	| "defaultCautionaryNoteToCompany"
	| "dealVendorNoteTemplate"
	| "estimationNoteTemplate"
> & {
	loginEmail: string;
	password: string;
};

export type VendorCompanyUpdatePasswordParam = {
	confirmPassword: string;
	newPassword: string;
	oldPassword: string;
};

export type InviteVendorCompany = {
	address: string;
	ceoFirstName: string;
	ceoLastName: string;
	checkTerm: boolean;
	confirmPassword: string;
	fax: string;
	loginEmail: string;
	name: string;
	password: string;
	postalCode: string;
	tel: string;
	userEmail: string;
	userName: string;
	userTel: string;
};

export const VENDOR_COMPANY_ITANDI_ID = 1;

export const vendorCompanyLoginSchema = object().shape({
	email: string().required("入力してください"),
	password: string().required("入力してください")
});

export const vendorCompanyLinkLoginSchema = object().shape({
	email: string()
		.required("入力してください")
		.email("メールアドレスの形式を確認してください"),
	password: string().required("入力してください")
});

export const vendorCompanyCreateValidationSchema = object().shape({
	address: string().required("入力してください"),
	ceoFirstName: string().required("入力してください"),
	ceoLastName: string().required("入力してください"),
	loginEmail: string()
		.required("入力してください")
		.email("メールアドレスの形式を確認してください"),
	name: string().required("入力してください"),
	password: applyPasswordRules(string().required("入力してください")),
	postalCode: string().required("入力してください")
});

export const vendorCompanyEditValidationSchema = object().shape({
	address: string().required("入力してください"),
	ceoFirstName: string().required("入力してください"),
	ceoLastName: string().required("入力してください"),
	dealVendorNoteTemplate: string().max(
		10000,
		"10000文字以内で設定してください"
	),
	defaultCautionaryNoteToCompany: string().max(
		10000,
		"10000文字以内で設定してください"
	),
	estimationNoteTemplate: string().max(400),
	loginEmail: string()
		.required("入力してください")
		.email("メールアドレスの形式を確認してください"),
	name: string().required("入力してください"),
	postalCode: string().required("入力してください")
});

export const commonNewPasswordValidationSchema = object().shape({
	confirmPassword: string()
		.required("入力してください")
		.test(
			"confirmPassword",
			"パスワードが一致しません",
			function testConfirmPassword(value: string | undefined) {
				const params: VendorCompanyUpdatePasswordParam = this.parent;
				if (params.newPassword === "" || params.newPassword === null) {
					return true;
				}
				return params.newPassword === value;
			}
		),
	newPassword: applyPasswordRules(string().required("入力してください"))
});
export const requireOldPasswordValidationSchema =
	commonNewPasswordValidationSchema.concat(
		object({
			oldPassword: string().required("入力してください")
		})
	);

export const validationSchemaInviteVendorCompany = object().shape({
	address: string().required("入力してください"),
	ceoFirstName: string().required("入力してください"),
	ceoLastName: string().required("入力してください"),
	checkTerm: boolean().isTrue("チェックしてください"),
	confirmPassword: string()
		.required("入力してください")
		.test(
			"passwordConfirm",
			"パスワードが一致しません",
			function testConfirmPassword(value: string | undefined) {
				const { password } = this.parent;
				if (password === "" || password === null) {
					return true;
				}
				return value === password;
			}
		),
	loginEmail: string()
		.required("入力してください")
		.email("メールアドレスの形式を確認してください"),
	name: string().required("入力してください"),
	password: applyPasswordRules(string().required("入力してください")),
	postalCode: string()
		.required("入力してください")
		.test(
			"len",
			"7桁で入力してください",
			(val: string | undefined) => !val || val.length === 7
		),
	tel: string().required("入力してください"),
	userEmail: string()
		.email("メールアドレスの形式を確認してください")
		.required("入力してください"),
	userName: string().required("入力してください"),
	userTel: string().required("入力してください")
});
